module.exports = __webpack_public_path__ + "static/GWLCnLogo-13a7ec38829acba21c0d51cae421ef9d.png";